import { createSelector } from "reselect";

const selectcit = state => state.cit;

export const selectScreen = createSelector(
  [selectcit],
  cit => cit.screen
);

export const selectCitData = createSelector(
  [selectcit],
  cit => cit.citData
);
export const selectPowerbiData = createSelector(
  [selectcit],
  cit => cit.powerbiData
);
